module.exports = __webpack_public_path__ + "img/product-five-3.8df35aa3.png";